import { PageRequest, PageResponse, WriteResponse } from "@/types/api-types";
import {
  ChatScene,
  ChatSceneEvent,
  ChatSceneCharacterTarget,
  ChatSceneCharacter,
  ChatSceneScore,
  ChatSceneScoreDefinition,
} from "@/types/chat";
import { deleteOne, get, post, put } from "@/modules/request";

export function readChatScenePage(
  params: PageRequest<{ mateId?: number; isCommon?: 0 | 1 }>
): Promise<PageResponse<ChatScene>> {
  return get("/ChatScenePage", params);
}

export function readChatScene(id: number): Promise<WriteResponse<ChatScene>> {
  return get(`/ChatScene/${id}`);
}

export function createOneChatScene(
  params: Partial<ChatScene> & { mateId: number; setAsDefault?: boolean }
): Promise<WriteResponse<ChatScene>> {
  return post("/ChatScene", params);
}

export function updateOneChatScene(
  id: number,
  params: Partial<ChatScene> & { setAsDefault?: boolean }
): Promise<WriteResponse<ChatScene>> {
  return put(`/ChatScene/${id}`, params);
}

export function deleteOneChatScene(id: number): Promise<WriteResponse<null>> {
  return deleteOne(`/ChatScene/${id}`);
}

export function createOneChatSceneTarget(
  params: Partial<ChatSceneCharacterTarget>
): Promise<WriteResponse<ChatSceneCharacterTarget>> {
  return post(`/ChatSceneTarget`, params);
}

export function updateOneChatSceneTarget(
  id: number,
  params: Partial<ChatSceneCharacterTarget>
): Promise<WriteResponse<ChatSceneCharacterTarget>> {
  return put(`/ChatSceneTarget/${id}`, params);
}

export function deleteOneChatSceneTarget(
  id: number
): Promise<WriteResponse<null>> {
  return deleteOne(`/ChatSceneTarget/${id}`);
}

export function createOneChatSceneEvent(
  params: Partial<ChatSceneEvent>
): Promise<WriteResponse<ChatSceneEvent>> {
  return post(`/ChatSceneEvent`, params);
}

export function updateOneChatSceneEvent(
  id: number,
  params: Partial<ChatSceneEvent>
): Promise<WriteResponse<ChatSceneEvent>> {
  return put(`/ChatSceneEvent/${id}`, params);
}

export function deleteOneChatSceneEvent(
  id: number
): Promise<WriteResponse<null>> {
  return deleteOne(`/ChatSceneEvent/${id}`);
}

export function updateOneChatSceneEventSort(
  id: number,
  direction: "up" | "down"
): Promise<WriteResponse<null>> {
  return post(`/ChatSceneEventSort/${id}`, { direction });
}

export function upsertManyChatSceneEvent(
  itemzz: Partial<ChatSceneEvent>[]
): Promise<WriteResponse<ChatSceneEvent[]>> {
  return post(`/ChatSceneEvent/UpsertMany`, { itemzz });
}

export function createOneChatSceneCharacter(
  chatSceneId: number,
  mateId: number
): Promise<WriteResponse<ChatSceneCharacter>> {
  return post(`/ChatSceneCharacter`, { chatSceneId, mateId });
}

export function deleteOneChatSceneCharacter(
  id: number
): Promise<WriteResponse<null>> {
  return deleteOne(`/ChatSceneCharacter/${id}`);
}

export function createChatSceneCharacterTarget(
  data: Partial<ChatSceneCharacterTarget>
): Promise<WriteResponse<ChatSceneCharacterTarget>> {
  return post(`/ChatSceneCharacterTarget`, data);
}

export function updateChatSceneCharacterTarget(
  id: number,
  data: Partial<ChatSceneCharacterTarget>
): Promise<WriteResponse<ChatSceneCharacterTarget>> {
  return put(`/ChatSceneCharacterTarget/${id}`, data);
}

export function deleteChatSceneCharacterTarget(
  id: number
): Promise<WriteResponse<null>> {
  return deleteOne(`/ChatSceneCharacterTarget/${id}`);
}

export function createChatSceneScore(
  data: Partial<ChatSceneScore>
): Promise<WriteResponse<ChatSceneScore>> {
  return post(`/ChatSceneScore`, data);
}

export function updateChatSceneScore(
  id: number,
  data: Partial<ChatSceneScore>
): Promise<WriteResponse<ChatSceneScore>> {
  return put(`/ChatSceneScore/${id}`, data);
}

export function deleteChatSceneScore(id: number): Promise<WriteResponse<null>> {
  return deleteOne(`/ChatSceneScore/${id}`);
}

export function createChatSceneScoreDefinition(
  data: Partial<ChatSceneScoreDefinition>
): Promise<WriteResponse<ChatSceneScoreDefinition>> {
  return post(`/ChatSceneScoreDefinition`, data);
}

export function updateChatSceneScoreDefinition(
  id: number,
  data: Partial<ChatSceneScoreDefinition>
): Promise<WriteResponse<ChatSceneScoreDefinition>> {
  return put(`/ChatSceneScoreDefinition/${id}`, data);
}

export function deleteChatSceneScoreDefinition(
  id: number
): Promise<WriteResponse<null>> {
  return deleteOne(`/ChatSceneScoreDefinition/${id}`);
}
